import React, { AnchorHTMLAttributes, forwardRef, ReactNode } from "react"

import Link from "next/link"

interface NextLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children: ReactNode
  className?: string
  newTab?: boolean
  external?: boolean
  prefetch?: boolean
  /** @deprecated App Router: используйте `href` с финальным путём */
  as?: string
  scroll?: boolean
  /**
   * @example
   * ```tsx
   * <Link href="/about" transitionTypes={['slide-in']}>About</Link>
   * ```
   */
  transitionTypes?: string[]
}

export const NextLink = forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ children, className, href, newTab, prefetch, as: _as, scroll, external, ...props }, ref) => {
    if (external) {
      return (
        <a
          ref={ref}
          className={className}
          href={href}
          target={newTab ? "_blank" : undefined}
          rel={newTab ? "noopener noreferrer" : undefined}
          {...props}
        >
          {children}
        </a>
      )
    }

    return (
      <Link
        ref={ref}
        href={href}
        prefetch={prefetch === false ? false : undefined}
        scroll={scroll}
        className={className}
        {...props}
      >
        {children}
      </Link>
    )
  },
)

NextLink.displayName = "NextLink"

export default NextLink
